/// <amd-module name="DistributedTask/Common/AzureResourcesService/Utils" />
import { IVssService, IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IProjectData, getTFSPageData } from "Tfs/Platform/Page";

export function getProject(pageContext: IVssPageContext): IProjectData | undefined {
    const tfsPageData = getTFSPageData(pageContext);

    if (tfsPageData && tfsPageData.project) {
        return tfsPageData.project;
    }

    return undefined;
}

export function safeParseJson(input?: string): any {
    let output = {};
    if (input) {
        try {
            output = JSON.parse(input) || {};
        } catch (e) { }
    }

    return output;
}

export function getResourceGroupFromClusterId(clusterId: string): string | undefined {
    if (!clusterId) {
        return;
    }

    const resourceGroupMatch = clusterId.match(
        /\/resourcegroups\/([-\w\._\(\)]+)\//i
    );
    return resourceGroupMatch ? resourceGroupMatch[1] : undefined;
}
